import { render, staticRenderFns } from "./m-fast-payment-system.vue?vue&type=template&id=5bd707c7&"
import script from "./m-fast-payment-system.vue?vue&type=script&lang=js&"
export * from "./m-fast-payment-system.vue?vue&type=script&lang=js&"
import style0 from "./m-fast-payment-system.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd707c7')) {
      api.createRecord('5bd707c7', component.options)
    } else {
      api.reload('5bd707c7', component.options)
    }
    module.hot.accept("./m-fast-payment-system.vue?vue&type=template&id=5bd707c7&", function () {
      api.rerender('5bd707c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/payment/fast-payment-system-modal/m-fast-payment-system.vue"
export default component.exports